import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function TermsConditionsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-df-bg pt-8 pb-16 px-4">
      <div className="container mx-auto max-w-4xl">
        {/* Header */}
        <div className="mb-10">
          <Link
            to="/"
            className="text-df-accent hover:text-df-accent-hover text-sm transition-colors mb-4 inline-block"
          >
            ← Volver al inicio
          </Link>
          <h1 className="text-3xl md:text-4xl font-cinzel font-bold text-df-text mb-2">
            Términos y Condiciones
          </h1>
          <p className="text-df-muted text-sm">
            Última actualización: Noviembre 2026
          </p>
        </div>

        {/* Content */}
        <div className="space-y-8 text-df-text/90 leading-relaxed">
          {/* 1 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              1. Aceptación de los Términos
            </h2>
            <p className="text-df-muted">
              Al acceder y utilizar el sitio web de <strong className="text-df-text">Tablero Infinito</strong> (en adelante, &ldquo;el Sitio&rdquo;), usted acepta cumplir con estos Términos y Condiciones en su totalidad. Si no está de acuerdo con alguno de estos términos, le solicitamos no utilizar nuestros servicios.
            </p>
            <p className="text-df-muted mt-3">
              Estos términos constituyen un acuerdo legal entre usted (el &ldquo;Usuario&rdquo;) y Tablero Infinito (el &ldquo;Vendedor&rdquo;) y regulan el uso del sitio web y la compra de productos a través de nuestra tienda en línea.
            </p>
          </section>

          {/* 2 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              2. Productos y Disponibilidad
            </h2>
            <ul className="space-y-3 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Todos los productos ofrecidos en el Sitio están sujetos a disponibilidad de inventario.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Nos esforzamos por mostrar imágenes y descripciones precisas de cada producto, sin embargo, pueden existir variaciones menores en color o presentación debido a las condiciones del monitor o a cambios del fabricante.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Nos reservamos el derecho de limitar las cantidades disponibles para compra y de descontinuar productos sin previo aviso.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Los productos en <strong className="text-df-text">preventa</strong> tienen tiempos de entrega estimados que pueden variar. El plazo específico será comunicado al momento de la compra.</span>
              </li>
            </ul>
          </section>

          {/* 3 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              3. Precios y Pagos
            </h2>
            <ul className="space-y-3 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Todos los precios publicados en el Sitio están expresados en <strong className="text-df-text">Pesos Colombianos (COP)</strong> e incluyen el IVA correspondiente, salvo que se indique lo contrario.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Nos reservamos el derecho de modificar los precios en cualquier momento sin previo aviso. El precio aplicable será el vigente al momento de realizar el pedido.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Los pagos se procesan de forma segura a través de <strong className="text-df-text">ePayco</strong>, plataforma de pagos certificada. Aceptamos tarjetas de crédito, débito, PSE y otros medios de pago habilitados.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>El pedido se confirmará una vez que el pago haya sido procesado y aprobado exitosamente.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Los costos de envío se calculan según la dirección de entrega y se muestran antes de confirmar la compra.</span>
              </li>
            </ul>
          </section>

          {/* 4 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              4. Proceso de Compra
            </h2>
            <p className="text-df-muted mb-3">El proceso de compra consta de los siguientes pasos:</p>
            <ol className="space-y-2 text-df-muted list-decimal list-inside">
              <li>Seleccionar los productos deseados y agregarlos al carrito de compras.</li>
              <li>Revisar el contenido del carrito y verificar las cantidades.</li>
              <li>Ingresar los datos de envío y seleccionar el método de entrega.</li>
              <li>Seleccionar el método de pago y completar la transacción.</li>
              <li>Recibir la confirmación del pedido por correo electrónico.</li>
            </ol>
            <p className="text-df-muted mt-3">
              La confirmación del pedido no garantiza la disponibilidad del producto. En caso de que un producto no esté disponible, nos comunicaremos con usted para ofrecer alternativas o proceder con el reembolso.
            </p>
          </section>

          {/* 5 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              5. Envíos y Entregas
            </h2>
            <ul className="space-y-3 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Realizamos envíos a todo el territorio colombiano a través de empresas de mensajería reconocidas.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Los tiempos de entrega estimados varían entre <strong className="text-df-text">3 a 10 días hábiles</strong> dependiendo de la ubicación del destinatario.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Una vez despachado el pedido, se proporcionará un número de guía para el seguimiento del envío.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Tablero Infinito no se hace responsable por demoras ocasionadas por la empresa transportadora, eventos de fuerza mayor o datos de entrega incorrectos proporcionados por el cliente.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Es responsabilidad del usuario verificar que los datos de envío sean correctos antes de confirmar la compra.</span>
              </li>
            </ul>
          </section>

          {/* 6 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              6. Devoluciones y Reembolsos
            </h2>
            <p className="text-df-muted mb-3">
              De acuerdo con la legislación colombiana (Ley 1480 de 2011 – Estatuto del Consumidor):
            </p>
            <ul className="space-y-3 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Derecho de retracto:</strong> El consumidor puede ejercer el derecho de retracto dentro de los 5 días hábiles siguientes a la entrega del producto, siempre que el producto se encuentre en su empaque original, sin uso y en perfectas condiciones. Los costos de transporte de la devolución corren por cuenta del consumidor, y le reintegramos el dinero pagado a más tardar dentro de los 30 días calendario siguientes.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Productos defectuosos:</strong> Si el producto presenta defectos de fábrica, el usuario tiene derecho a solicitar la reparación, cambio o devolución del dinero dentro de los plazos establecidos por la garantía legal.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Proceso:</strong> Para iniciar una devolución, contacte a nuestro equipo de soporte a través de <a href="mailto:tableroinfinito@gmail.com" className="text-df-accent hover:text-df-accent-hover transition-colors">tableroinfinito@gmail.com</a> o WhatsApp indicando el número de pedido y el motivo de la devolución.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Reembolsos:</strong> Una vez aprobada la devolución, el reembolso se procesará en un plazo de 10 a 15 días hábiles al medio de pago original.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Exclusiones:</strong> No se aceptan devoluciones de productos que presenten señales de uso, daños causados por el usuario, o que no se encuentren en su empaque original.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span><strong className="text-df-text">Reversión del pago:</strong> si pagó con tarjeta, PSE u otro medio electrónico y fue objeto de fraude, la operación no fue autorizada, el producto no llegó o no corresponde a lo comprado o está defectuoso, puede pedir la reversión del pago dentro de los 5 días hábiles siguientes a cuando lo supo. Debe avisarnos a <a href="mailto:tableroinfinito@gmail.com" className="text-df-accent hover:text-df-accent-hover transition-colors">tableroinfinito@gmail.com</a> y al emisor de su medio de pago, y devolver el producto si lo recibió.</span>
              </li>
            </ul>
          </section>

          {/* 7 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              7. Garantía
            </h2>
            <p className="text-df-muted">
              Todos nuestros productos cuentan con la garantía legal establecida por la legislación colombiana. Los juegos de mesa, cartas y accesorios tienen una garantía contra defectos de fabricación (por ejemplo, piezas o cartas faltantes o dañadas de fábrica) de un (1) año contado desde la entrega. La garantía no cubre daños causados por mal uso, desgaste natural, modificaciones no autorizadas o accidentes.
            </p>
            <p className="text-df-muted mt-3">
              Para hacer efectiva la garantía, el usuario debe presentar el comprobante de compra y el producto en las condiciones en que se evidencie el defecto.
            </p>
          </section>

          {/* 8 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              8. Cuenta de Usuario
            </h2>
            <ul className="space-y-3 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Para realizar compras puede crear una cuenta en nuestro sitio o comprar como invitado.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>El usuario es responsable de mantener la confidencialidad de sus credenciales de acceso.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Cualquier actividad realizada desde su cuenta es responsabilidad del titular.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Nos reservamos el derecho de suspender o cancelar cuentas que violen estos términos o muestren actividad sospechosa.</span>
              </li>
            </ul>
          </section>

          {/* 9 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              9. Propiedad Intelectual
            </h2>
            <p className="text-df-muted">
              Todo el contenido del Sitio, incluyendo pero no limitado a textos, gráficos, logotipos, imágenes, fotografías, diseño del sitio, software y marcas registradas, son propiedad de Tablero Infinito o de sus respectivos titulares y están protegidos por las leyes de propiedad intelectual colombianas e internacionales.
            </p>
            <p className="text-df-muted mt-3">
              Queda prohibida la reproducción, distribución, modificación o uso no autorizado de cualquier contenido del Sitio sin el consentimiento previo y por escrito de Tablero Infinito.
            </p>
          </section>

          {/* 10 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              10. Limitación de Responsabilidad
            </h2>
            <ul className="space-y-3 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Tablero Infinito no será responsable por daños indirectos, incidentales o consecuentes derivados del uso del Sitio o de los productos adquiridos.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>No garantizamos que el Sitio funcione de forma ininterrumpida o libre de errores en todo momento.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>No somos responsables por el contenido de sitios web de terceros enlazados desde nuestro Sitio.</span>
              </li>
            </ul>
          </section>

          {/* 11 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              11. Cupones y Promociones
            </h2>
            <ul className="space-y-3 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Los cupones de descuento y promociones tienen condiciones específicas de uso, fecha de vigencia y productos aplicables.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Los cupones son de uso único salvo que se indique lo contrario y no son acumulables entre sí.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Nos reservamos el derecho de cancelar o modificar promociones en cualquier momento.</span>
              </li>
            </ul>
          </section>

          {/* 12 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              12. Asistente de Ventas en el Chat
            </h2>
            <p className="text-df-muted">
              El chat de la página es atendido por un asistente automático. La información que da sobre productos, precios, disponibilidad y envíos es orientativa: prevalecen el precio, la disponibilidad y las condiciones que muestren la ficha del producto y el carrito al momento de la compra.
            </p>
            <ul className="space-y-2 text-df-muted mt-3">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>El asistente no crea pedidos, no recibe pagos y no puede ofrecer descuentos. Las compras se hacen en el carrito de la página.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Nunca le pedirá datos de tarjetas, contraseñas ni códigos de verificación.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Para reclamos, devoluciones o garantías, el asistente le indicará cómo contactar a nuestro equipo por WhatsApp o correo electrónico.</span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>El tratamiento de sus conversaciones se explica en nuestra Política de Privacidad.</span>
              </li>
            </ul>
          </section>

          {/* 13 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              13. Legislación Aplicable y Jurisdicción
            </h2>
            <p className="text-df-muted">
              Estos Términos y Condiciones se rigen por las leyes de la República de Colombia. Cualquier controversia derivada del uso del Sitio o de la compra de productos será sometida a la jurisdicción de los tribunales competentes de Colombia, sin perjuicio de los derechos que asisten al consumidor conforme al Estatuto del Consumidor (Ley 1480 de 2011).
            </p>
          </section>

          {/* 14 */}
          <section className="bg-df-surface border border-df-border rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              14. Modificaciones a los Términos
            </h2>
            <p className="text-df-muted">
              Tablero Infinito se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones entrarán en vigor desde su publicación en el Sitio. El uso continuado del Sitio después de la publicación de cambios constituye la aceptación de los nuevos términos.
            </p>
          </section>

          {/* Contact */}
          <section className="bg-df-surface border border-df-accent/20 rounded-xl p-6 md:p-8">
            <h2 className="text-xl font-cinzel font-semibold text-df-text mb-4">
              Contacto
            </h2>
            <p className="text-df-muted mb-3">
              Si tiene preguntas sobre estos Términos y Condiciones, puede contactarnos a través de:
            </p>
            <ul className="space-y-2 text-df-muted">
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>Correo electrónico: <a href="mailto:tableroinfinito@gmail.com" className="text-df-accent hover:text-df-accent-hover transition-colors">tableroinfinito@gmail.com</a></span>
              </li>
              <li className="flex gap-2">
                <span className="text-df-accent font-bold">•</span>
                <span>WhatsApp: <a href="https://wa.me/573021124424" className="text-df-accent hover:text-df-accent-hover transition-colors" target="_blank" rel="noopener noreferrer">+57 302 112 4424</a></span>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
